import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6 py-4" }
const _hoisted_2 = { class: "text-lg" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = {
  key: 0,
  class: "px-6 py-4 bg-gray-100 text-right rounded-b-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    show: _ctx.show,
    onShown: _ctx.shown,
    "max-width": _ctx.maxWidth,
    closeable: _ctx.closeable,
    onClose: _ctx.close
  }, {
    default: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "title", { close: close })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "content", { close: close })
        ])
      ]),
      (_ctx.hasFooterContent())
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "footer", { close: close })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["show", "onShown", "max-width", "closeable", "onClose"]))
}